import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import * as styles from "./style.module.css";
import SocialNetworkLinks from "../SocialNetworkLinks";

const Footer: React.FC<{ fixed: boolean }> = ({ fixed }) => {
  const goToMissionPage = () => {
    window.location.href = "/mission/";
  };

  const goToProfilePage = () => {
    window.location.href = "/users/me/";
  };

  const goToBlogPage = () => {
    window.location.href = "/blog/";
  };

  const goToPartnershipsPage = () => {
    window.location.href = "/affiliate/";
  };

  const goToFreeProtein = () => {
    window.location.href = "/referral/";
  };

  const goToReviews = () => {
    window.location.href = "/reviews/";
  };

  const goToTerms = () => {
    window.location.href = "/terms/";
  };

  const goToRewards = () => {
    window.location.href = "/rewards/";
  };

  return (
    <div className={`${fixed ? styles.fixed : ""} ${styles.footerContainer}`}>
      <a className={styles.footerContainerLogo} href="/">
        <StaticImage
          className={styles.gaifulLogo}
          width={49}
          alt="Gainful"
          src="../../images/logo-light.webp"
        />
      </a>
      <div className={styles.infoContainer}>
        <div className={styles.footerHeader}>Formulated for you.</div>
        <div className={styles.infoBlock}>
          <div className={styles.info}>
            <button type="button" onClick={goToMissionPage}>
              Mission
            </button>
            <a href="https://help.gainful.com/hc/en-us">Help</a>
            <button type="button" onClick={goToProfilePage}>
              Profile
            </button>
            <a href="/careers/">Careers</a>
            <button type="button" onClick={goToBlogPage}>
              Blog
            </button>
            <button type="button">Sustainability</button>
          </div>
          <div className={styles.info}>
            <button type="button" onClick={goToPartnershipsPage}>
              Partnerships
            </button>
            <button type="button" onClick={goToFreeProtein}>
              free protein
            </button>
            <button type="button" onClick={goToReviews}>
              Reviews
            </button>
            <button type="button" onClick={goToRewards}>
             Rewards
            </button>
          </div>
        </div>

        <SocialNetworkLinks />
      </div>
      <div className={styles.contactsContainer}>
        <div className={styles.contacts}>
          <div className={styles.address}>
            <div>6 West 18th St, #10F</div>
            <div>New York, NY 10011</div>
            <div>hello@gainful.com </div>
            <div>(415) 991-7243</div>
          </div>
          <div className={styles.warningMobile}>
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure or prevent any disease.
          </div>
          <div className={styles.privacyContainer}>
            <div className={styles.copy}>© 2022 GAINFUL HEALTH Inc.</div>
            <div className={styles.privacyContainerLinks}>
              <button type="button" onClick={goToTerms}>
                Terms and Privacy
              </button>
            </div>
          </div>
        </div>
        <div className={styles.warningDesktop}>
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure
          or prevent any disease.
        </div>
      </div>
    </div>
  );
};

export default Footer;
